import {UsersDTO} from "./UsersDTO";

export const InitUsersDTO : UsersDTO = {
  id : "",
  userId : "",
  userPassword : "",
  email : "",
  src : "" ,
  roles : [],
}